import { SaveToReportMenuItemProps } from '@/types/widget';

export const defaultWidgetReportData: SaveToReportMenuItemProps = {
  visType: 'radar',
  dataType: 'aggregate',
};
